export default __webpack_public_path__ + "static/with-tablet-c36ed20331e1d3eaea7d0f98736ec751.png";